'use strict';

var db = null;

var DBNAME = 'storelogs';
var STORENAME = 'logs';
var interval = null;

(function () {
    var DBOpenRequest = indexedDB.open(DBNAME, 5);

    DBOpenRequest.onerror = function (event) {
        console.log('Error loading database');
    };

    DBOpenRequest.onsuccess = function (event) {
        console.log(' onsuccess');
        db = DBOpenRequest.result;
    };

    DBOpenRequest.onupgradeneeded = function (event) {
        console.log('onupgradeneeded');
        var db = DBOpenRequest.result;
        // Create an objectStore for this databas
        db.createObjectStore(STORENAME, { autoIncrement: true });
    };
})();

// // Fix bug:GEN-136634 for IE Browser does'nt support IndexedDb IDBObjectStore.getAll method
if (IDBObjectStore.prototype.getAll === undefined) {
    var IDBRequest = function IDBRequest() {
        this.readyState = 'pending';
        this.onsuccess = null;
    };

    IDBObjectStore.prototype.getAll = function getAllFromStore() {
        var cursorRequest,
            getAllRequest = new IDBRequest(),
            result = [];

        cursorRequest = this.openCursor();
        cursorRequest.onsuccess = function (event) {
            var cursorResult = event.target.result;

            if (cursorResult) {
                result.push(cursorResult.value);
                cursorResult.continue();
                return;
            }

            getAllRequest.result = result;
            getAllRequest.onsuccess();
        };

        return getAllRequest;
    };
}

onmessage = function onmessage(event) {
    var config = null;

    var OnboardLog = function OnboardLog(log) {
        config = event.data.config;

        if (interval === null && config && config.timeInterval) {
            interval = setInterval(getSendDeletelogs(), config.timeInterval);
        }

        var configOptions = findLogLevel(log);

        if (configOptions.required !== false) {
            if (configOptions.sendImmediately !== false) {
                sendLogs([log], true);
            } else {

                if (db == null) {
                    console.log('Unfortunately Indexed db is not yet created');
                    return;
                }

                var countRequest = getCount();

                if (countRequest == null) {
                    return;
                }

                countRequest.onsuccess = function () {
                    var currentSizeLogs = countRequest.result;
                    if (config.batchSize && ++currentSizeLogs >= config.batchSize) {

                        var getAllRequest = getAll();
                        getAllRequest.onsuccess = function () {
                            var logs = getAllRequest.result;
                            logs.push(log);
                            sendLogs(logs, false);
                        };
                    } else {
                        add(log);
                    }
                };
            }
        }
    };

    var findLogLevel = function findLogLevel(log) {
        if (log.level === 'ERROR') {
            return config.error;
        } else if (log.level === 'WARNING') {
            return config.warning;
        } else if (log.level === 'INFO') {
            return config.info;
        } else return config.fatal;
    };

    var sendLogs = function sendLogs(logs, sendImmediately) {
        console.log('sending logs');
        postMessage({ logs: logs, sendImmediately: sendImmediately });
    };

    var getObjectStore = function getObjectStore(store_name, mode) {

        if (db === null) {
            return null;
        }
        var tx = null;
        try {
            var tx = db.transaction(store_name, mode);
            tx.onerror = function (err) {
                console.log('Unable to create Inexed Db transaction', err.code + ' - ' + err.message + ' - ' + err.stack);
            };
        } catch (err) {
            console.log(err.code + ' - ' + err.message + ' - ' + err.stack);
            return null;
        }

        return tx.objectStore(store_name);
    };

    var getAll = function getAll() {
        var store = getObjectStore(STORENAME, 'readonly');
        var req = store.getAll();
        return req;
    };

    var getCount = function getCount() {
        var store = getObjectStore(STORENAME, 'readonly');
        if (store == null) {
            return null;
        }
        var req = store.count();
        return req;
    };
    var deleteLogs = function deleteLogs() {
        var store = getObjectStore(STORENAME, 'readwrite');
        var req = store.clear();
        req.onsuccess = function () {
            console.log('successfully Cleard the db');
        };
    };

    var add = function add(log) {

        var store = getObjectStore(STORENAME, 'readwrite');
        var req = store.add(log);
        req.onsuccess = function () {
            console.log('Added successfully');
        };
        req.onerror = function () {
            console.log('error');
        };
    };

    var getSendDeletelogs = function getSendDeletelogs() {
        console.log('cyclically : sending and deleting');
        postMessage({});
    };

    if (event.data.log) {
        OnboardLog(event.data.log);
    }
};